'use strict';
import BasePreprocessor from './BasePreprocessor';
import DataQueryEnums from '../DataQueryEnumerations';

const ColumnSortingEnum = DataQueryEnums.ColumnSortingEnum;

export default class SortingPreprocessor extends BasePreprocessor {
	constructor(personalizationService) {
		super();

		this.personalizationService = personalizationService;

		Object.defineProperty(this, 'sortedColumns', {
			get: function () {
				return this._sortedColumns;
			},
		});
	}

	init(executor) {
		Object.defineProperties(this, {
			columns: {
				get: function () {
					return executor.columns || [];
				},
			},
			sortableColumns: {
				enumerable: true,
				get: function () {
					return this.columns.filter(function (column) {
						return column.Sorting !== ColumnSortingEnum.Disabled;
					});
				},
			},
		});

		const sortedColumnsConfig = [];
		this.sortableColumns.forEach(function (column) {
			if (column.Sorting !== ColumnSortingEnum.None) {
				sortedColumnsConfig.push({
					name: column.Name,
					sorting: column.Sorting,
					priority: column.SortingPriority,
				});
			}
		});

		this._sortedColumns = this._applySortToColumns(sortedColumnsConfig);

		this._defaultSorting = this.sortableColumns.reduce((defaultSorting, column) => {
			defaultSorting[column.Name] = {
				sorting: column.Sorting,
				priority: column.SortingPriority,
			};
			return defaultSorting;
		}, {});
	}

	enableSingleColumnMode() {
		this.singleColumnMode = true;
	}

	initPersonalization(personalizationKey) {
		this.personalizationKey = personalizationKey;

		if (personalizationKey) {
			return this.personalizationService.getGridPersonalization(personalizationKey).then(
				function (personalization) {
					if (typeof personalization !== 'object' || !Object.keys(personalization).length) {
						return;
					}
					var sortedColumnsConfig = [];

					this.columns.forEach(function (column) {
						if (personalization[column.Name] && typeof personalization[column.Name].Sorting === 'number') {
							sortedColumnsConfig.push({
								name: column.Name,
								sorting: personalization[column.Name].Sorting,
								priority: personalization[column.Name].SortingPriority,
							});
						}
					});

					if (sortedColumnsConfig.length) {
						this._sortedColumns = this._applySortToColumns(sortedColumnsConfig);
					}
				}.bind(this)
			);
		}
	}

	setSort(sortedColumnsConfig) {
		this._sortedColumns = this._applySortToColumns(sortedColumnsConfig);

		if (this.personalizationKey) {
			var sortingPersonalization = this.sortableColumns
				.filter(function (column) {
					return this._defaultSorting[column.Name].sorting !== column.Sorting || this._defaultSorting[column.Name].priority !== column.SortingPriority;
				}, this)
				.map(function (column) {
					return {
						name: column.Name,
						sorting: column.Sorting,
						priority: column.SortingPriority,
					};
				});
			this.personalizationService.savePersonalizedSorting(sortingPersonalization, this.personalizationKey);
		}
		this.changed();
	}

	_isColumnSortable(columnName) {
		return this.sortableColumns.some((column) => column.Name === columnName);
	}

	_checkSortedConfig(sortedColumnsConfig) {
		if (!Array.isArray(sortedColumnsConfig)) {
			return [];
		}

		sortedColumnsConfig = sortedColumnsConfig.filter((column) => {
			return column.name && this._isColumnSortable(column.name) && (column.sorting === ColumnSortingEnum.Ascending || column.sorting === ColumnSortingEnum.Descending);
		});

		if (!this.singleColumnMode) {
			return sortedColumnsConfig;
		}

		if (sortedColumnsConfig.length > 1) {
			sortedColumnsConfig = [sortedColumnsConfig[0]];
		} else if (sortedColumnsConfig.length === 0 && this.sortableColumns.length) {
			sortedColumnsConfig = [
				{
					name: this.sortableColumns[0].Name,
					sorting: ColumnSortingEnum.Ascending,
					priority: this.sortableColumns[0].Priority,
				},
			];
		}

		return sortedColumnsConfig;
	}

	_applySortToColumns(sortedColumnsConfig) {
		var sorted = [];
		sortedColumnsConfig = this._checkSortedConfig(sortedColumnsConfig);
		this.sortableColumns.forEach(function (column) {
			var sortedColumn = _.find(sortedColumnsConfig, ['name', column.Name]);
			if (!sortedColumn) {
				if (column.Sorting === ColumnSortingEnum.Ascending || column.Sorting === ColumnSortingEnum.Descending) {
					column.Sorting = ColumnSortingEnum.None;
					column.SortingPriority = 0;
				}
			} else {
				column.Sorting = sortedColumn.sorting;
				column.SortingPriority = sortedColumn.priority;
				if (column.Sorting !== ColumnSortingEnum.None) {
					sorted.push(column);
				}
			}
		}, this);

		sorted.sort(function (columnA, columnB) {
			return columnA.SortingPriority - columnB.SortingPriority;
		});

		return sorted;
	}
}
SortingPreprocessor.$inject = ['mx.SolutionBuilderAgent.PersonalizationService'];
